import React from "react";
import { Register } from "../containers";

export default function RegisterPage() {
    return <Register />;
}
